import {Component, OnInit} from '@angular/core'
import {UserDto} from '@api/users/interfaces'
import {ActivatedRoute} from '@angular/router'
import {UserRestService} from '../../../services/rest/user-rest.service'

@Component({
	selector: 'app-user-stamm',
	templateUrl: './stammdaten.component.html',
	styleUrls: ['./stammdaten.component.scss',]
})
export class UserStammdatenComponent implements OnInit {
	username: string
	user: UserDto

	constructor(
		private route: ActivatedRoute,
		private userService: UserRestService,
	) {}

	async ngOnInit(): Promise<void> {
		this.username = this.route.snapshot.paramMap.get('name')
		this.user = await this.userService.userByUsername(this.username)
	}
}
